import { useMemo, useState } from "react";

const DEFAULT_PAGE = 1;
const DEFAULT_SORTING = "";

export default function useFilters({
                                       initialCategories = [],
                                       initialBrands = [],
                                       initialProducts = [],
                                       initialColors = [],
                                       initialPriceMin = null,
                                       initialPriceMax = null,
                                       initialSorting = DEFAULT_SORTING,
                                   } = {}) {
    const [filters, setFilters] = useState({
        categories: initialCategories,
        brands: initialBrands,
        products: initialProducts,
        colors: initialColors,
        priceMin: initialPriceMin,
        priceMax: initialPriceMax,
        sorting: initialSorting,
    });

    const [page, setPage] = useState(DEFAULT_PAGE);

    const toggleFilter = (type, id, { single = false } = {}) => {
        const normalizedId = String(id);

        setFilters((prev) => {
            const current = (prev[type] || []).map(String);
            const isSelected = current.includes(normalizedId);

            if (single) {
                return {
                    ...prev,
                    [type]: isSelected ? [] : [normalizedId],
                };
            }

            return {
                ...prev,
                [type]: isSelected
                    ? current.filter((x) => x !== normalizedId)
                    : [...current, normalizedId],
            };
        });

        setPage(DEFAULT_PAGE);
    };

    const setRange = (min, max) => {
        setFilters((prev) => ({
            ...prev,
            priceMin: min,
            priceMax: max,
        }));
        setPage(DEFAULT_PAGE);
    };

    const setSorting = (value) => {
        setFilters((prev) => ({
            ...prev,
            sorting: value,
        }));
        setPage(DEFAULT_PAGE);
    };

    const resetAll = ({ min = 0, max = 0 } = {}) => {
        setFilters({
            categories: [],
            brands: [],
            products: [],
            colors: [],
            priceMin: null,
            priceMax: null,
            sorting: DEFAULT_SORTING,
        });

        setPage(DEFAULT_PAGE);
    };



    const apiQuery = useMemo(() => ({
        categories: filters.categories,
        brands: filters.brands,
        products: filters.products,
        colors: filters.colors,
        price: {
            min: filters.priceMin,
            max: filters.priceMax,
        },
        sorting: filters.sorting,
        page,
    }), [filters, page]);

    return {
        filters,
        page,
        setFilters,
        setPage,
        toggleFilter,
        setRange,
        setSorting,
        resetAll,
        apiQuery,
    };
}